import { Model } from 'backbone';

export class Subscription extends Model {

	initialize() {
		this.prefix = 'payment/';
	}

	setSubscribeUrl() {
		this.url = 'subscribe';

		return this;
	}

	setUnsubscribe() {
		this.url = 'unsubscribe';

		return this;
	}

	setTransactionHistoryUrl() {
		this.url = 'transaction_history';

		return this;
	}

	setCodesubscribe() {
		this.url = 'free_code';

		return this;
	}

	async createStripeToken(card) {
		return window.stripe.createToken(card.card_number);
	}
}

export default Subscription;